import { _ as G, P as e, k as ie, b as le, g as ce } from "./createTheme-6e68f5ca.js";
import * as $ from "react";
import { l as ae, m as ue, n as fe, o as pe, c as de, p as me, a as ge, s as be, u as ye } from "./Search-4d6031ad.js";
import { jsx as W } from "react/jsx-runtime";
function ze(n, r) {
  if (process.env.NODE_ENV === "production")
    return () => null;
  const o = r ? G({}, r.propTypes) : null;
  return (i) => (t, l, a, d, c, ...y) => {
    const m = c || l, g = o == null ? void 0 : o[m];
    if (g) {
      const p = g(t, l, a, d, c, ...y);
      if (p)
        return p;
    }
    return typeof t[l] < "u" && !t[i] ? new Error(`The prop \`${m}\` of \`${n}\` can only be used together with the \`${i}\` prop.`) : null;
  };
}
const Oe = ae(), $e = Oe, Ge = (n, r) => n.filter((o) => r.includes(o)), v = (n, r, o) => {
  const s = n.keys[0];
  Array.isArray(r) ? r.forEach((i, t) => {
    o((l, a) => {
      t <= n.keys.length - 1 && (t === 0 ? Object.assign(l, a) : l[n.up(n.keys[t])] = a);
    }, i);
  }) : r && typeof r == "object" ? (Object.keys(r).length > n.keys.length ? n.keys : Ge(n.keys, Object.keys(r))).forEach((t) => {
    if (n.keys.indexOf(t) !== -1) {
      const l = r[t];
      l !== void 0 && o((a, d) => {
        s === t ? Object.assign(a, d) : a[n.up(t)] = d;
      }, l);
    }
  }) : (typeof r == "number" || typeof r == "string") && o((i, t) => {
    Object.assign(i, t);
  }, r);
};
function f(n) {
  return n ? `Level${n}` : "";
}
function T(n) {
  return n.unstable_level > 0 && n.container;
}
function L(n) {
  return function(o) {
    return `var(--Grid-${o}Spacing${f(n.unstable_level)})`;
  };
}
function C(n) {
  return function(o) {
    return n.unstable_level === 0 ? `var(--Grid-${o}Spacing)` : `var(--Grid-${o}Spacing${f(n.unstable_level - 1)})`;
  };
}
function k(n) {
  return n.unstable_level === 0 ? "var(--Grid-columns)" : `var(--Grid-columns${f(n.unstable_level - 1)})`;
}
const ve = ({
  theme: n,
  ownerState: r
}) => {
  const o = L(r), s = {};
  return v(n.breakpoints, r.gridSize, (i, t) => {
    let l = {};
    t === !0 && (l = {
      flexBasis: 0,
      flexGrow: 1,
      maxWidth: "100%"
    }), t === "auto" && (l = {
      flexBasis: "auto",
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: "none",
      width: "auto"
    }), typeof t == "number" && (l = {
      flexGrow: 0,
      flexBasis: "auto",
      width: `calc(100% * ${t} / ${k(r)}${T(r) ? ` + ${o("column")}` : ""})`
    }), i(s, l);
  }), s;
}, xe = ({
  theme: n,
  ownerState: r
}) => {
  const o = {};
  return v(n.breakpoints, r.gridOffset, (s, i) => {
    let t = {};
    i === "auto" && (t = {
      marginLeft: "auto"
    }), typeof i == "number" && (t = {
      marginLeft: i === 0 ? "0px" : `calc(100% * ${i} / ${k(r)})`
    }), s(o, t);
  }), o;
}, Te = ({
  theme: n,
  ownerState: r
}) => {
  if (!r.container)
    return {};
  const o = T(r) ? {
    [`--Grid-columns${f(r.unstable_level)}`]: k(r)
  } : {
    "--Grid-columns": 12
  };
  return v(n.breakpoints, r.columns, (s, i) => {
    s(o, {
      [`--Grid-columns${f(r.unstable_level)}`]: i
    });
  }), o;
}, he = ({
  theme: n,
  ownerState: r
}) => {
  if (!r.container)
    return {};
  const o = C(r), s = T(r) ? {
    // Set the default spacing as its parent spacing.
    // It will be overridden if spacing props are provided
    [`--Grid-rowSpacing${f(r.unstable_level)}`]: o("row")
  } : {};
  return v(n.breakpoints, r.rowSpacing, (i, t) => {
    var l;
    i(s, {
      [`--Grid-rowSpacing${f(r.unstable_level)}`]: typeof t == "string" ? t : (l = n.spacing) == null ? void 0 : l.call(n, t)
    });
  }), s;
}, Se = ({
  theme: n,
  ownerState: r
}) => {
  if (!r.container)
    return {};
  const o = C(r), s = T(r) ? {
    // Set the default spacing as its parent spacing.
    // It will be overridden if spacing props are provided
    [`--Grid-columnSpacing${f(r.unstable_level)}`]: o("column")
  } : {};
  return v(n.breakpoints, r.columnSpacing, (i, t) => {
    var l;
    i(s, {
      [`--Grid-columnSpacing${f(r.unstable_level)}`]: typeof t == "string" ? t : (l = n.spacing) == null ? void 0 : l.call(n, t)
    });
  }), s;
}, _e = ({
  theme: n,
  ownerState: r
}) => {
  if (!r.container)
    return {};
  const o = {};
  return v(n.breakpoints, r.direction, (s, i) => {
    s(o, {
      flexDirection: i
    });
  }), o;
}, Ee = ({
  ownerState: n
}) => {
  const r = L(n), o = C(n);
  return G({
    minWidth: 0,
    boxSizing: "border-box"
  }, n.container && G({
    display: "flex",
    flexWrap: "wrap"
  }, n.wrap && n.wrap !== "wrap" && {
    flexWrap: n.wrap
  }, {
    margin: `calc(${r("row")} / -2) calc(${r("column")} / -2)`
  }, n.disableEqualOverflow && {
    margin: `calc(${r("row")} * -1) 0px 0px calc(${r("column")} * -1)`
  }), (!n.container || T(n)) && G({
    padding: `calc(${o("row")} / 2) calc(${o("column")} / 2)`
  }, (n.disableEqualOverflow || n.parentDisableEqualOverflow) && {
    padding: `${o("row")} 0px 0px ${o("column")}`
  }));
}, we = (n) => {
  const r = [];
  return Object.entries(n).forEach(([o, s]) => {
    s !== !1 && s !== void 0 && r.push(`grid-${o}-${String(s)}`);
  }), r;
}, je = (n, r = "xs") => {
  function o(s) {
    return s === void 0 ? !1 : typeof s == "string" && !Number.isNaN(Number(s)) || typeof s == "number" && s > 0;
  }
  if (o(n))
    return [`spacing-${r}-${String(n)}`];
  if (typeof n == "object" && !Array.isArray(n)) {
    const s = [];
    return Object.entries(n).forEach(([i, t]) => {
      o(t) && s.push(`spacing-${i}-${String(t)}`);
    }), s;
  }
  return [];
}, Ne = (n) => n === void 0 ? [] : typeof n == "object" ? Object.entries(n).map(([r, o]) => `direction-${r}-${o}`) : [`direction-xs-${String(n)}`], Pe = ["className", "children", "columns", "container", "component", "direction", "wrap", "spacing", "rowSpacing", "columnSpacing", "disableEqualOverflow", "unstable_level"], Ce = ie(), ke = $e("div", {
  name: "MuiGrid",
  slot: "Root",
  overridesResolver: (n, r) => r.root
});
function qe(n) {
  return ue({
    props: n,
    name: "MuiGrid",
    defaultTheme: Ce
  });
}
function De(n = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: r = ke,
    useThemeProps: o = qe,
    componentName: s = "MuiGrid"
  } = n, i = /* @__PURE__ */ $.createContext(void 0);
  process.env.NODE_ENV !== "production" && (i.displayName = "GridOverflowContext");
  const t = (d, c) => {
    const {
      container: y,
      direction: m,
      spacing: g,
      wrap: p,
      gridSize: h
    } = d, S = {
      root: ["root", y && "container", p !== "wrap" && `wrap-xs-${String(p)}`, ...Ne(m), ...we(h), ...y ? je(g, c.breakpoints.keys[0]) : []]
    };
    return ge(S, (_) => ce(s, _), {});
  }, l = r(Te, Se, he, ve, _e, Ee, xe), a = /* @__PURE__ */ $.forwardRef(function(c, y) {
    var m, g, p, h, S, _, q, D;
    const w = fe(), U = o(c), j = pe(U), E = $.useContext(i), {
      className: F,
      children: K,
      columns: H = 12,
      container: I = !1,
      component: J = "div",
      direction: Q = "row",
      wrap: X = "wrap",
      spacing: N = 0,
      rowSpacing: Y = N,
      columnSpacing: Z = N,
      disableEqualOverflow: R,
      unstable_level: b = 0
    } = j, ee = le(j, Pe);
    let x = R;
    b && R !== void 0 && (x = c.disableEqualOverflow);
    const M = {}, V = {}, z = {};
    Object.entries(ee).forEach(([u, O]) => {
      w.breakpoints.values[u] !== void 0 ? M[u] = O : w.breakpoints.values[u.replace("Offset", "")] !== void 0 ? V[u.replace("Offset", "")] = O : z[u] = O;
    });
    const ne = (m = c.columns) != null ? m : b ? void 0 : H, re = (g = c.spacing) != null ? g : b ? void 0 : N, oe = (p = (h = c.rowSpacing) != null ? h : c.spacing) != null ? p : b ? void 0 : Y, te = (S = (_ = c.columnSpacing) != null ? _ : c.spacing) != null ? S : b ? void 0 : Z, B = G({}, j, {
      level: b,
      columns: ne,
      container: I,
      direction: Q,
      wrap: X,
      spacing: re,
      rowSpacing: oe,
      columnSpacing: te,
      gridSize: M,
      gridOffset: V,
      disableEqualOverflow: (q = (D = x) != null ? D : E) != null ? q : !1,
      // use context value if exists.
      parentDisableEqualOverflow: E
      // for nested grid
    }), se = t(B, w);
    let P = /* @__PURE__ */ W(l, G({
      ref: y,
      as: J,
      ownerState: B,
      className: de(se.root, F)
    }, z, {
      children: $.Children.map(K, (u) => {
        if (/* @__PURE__ */ $.isValidElement(u) && me(u, ["Grid"])) {
          var O;
          return /* @__PURE__ */ $.cloneElement(u, {
            unstable_level: (O = u.props.unstable_level) != null ? O : b + 1
          });
        }
        return u;
      })
    }));
    return x !== void 0 && x !== (E ?? !1) && (P = /* @__PURE__ */ W(i.Provider, {
      value: x,
      children: P
    })), P;
  });
  return process.env.NODE_ENV !== "production" && (a.propTypes = {
    children: e.node,
    className: e.string,
    columns: e.oneOfType([e.arrayOf(e.number), e.number, e.object]),
    columnSpacing: e.oneOfType([e.arrayOf(e.oneOfType([e.number, e.string])), e.number, e.object, e.string]),
    component: e.elementType,
    container: e.bool,
    direction: e.oneOfType([e.oneOf(["column-reverse", "column", "row-reverse", "row"]), e.arrayOf(e.oneOf(["column-reverse", "column", "row-reverse", "row"])), e.object]),
    disableEqualOverflow: e.bool,
    lg: e.oneOfType([e.oneOf(["auto"]), e.number, e.bool]),
    lgOffset: e.oneOfType([e.oneOf(["auto"]), e.number]),
    md: e.oneOfType([e.oneOf(["auto"]), e.number, e.bool]),
    mdOffset: e.oneOfType([e.oneOf(["auto"]), e.number]),
    rowSpacing: e.oneOfType([e.arrayOf(e.oneOfType([e.number, e.string])), e.number, e.object, e.string]),
    sm: e.oneOfType([e.oneOf(["auto"]), e.number, e.bool]),
    smOffset: e.oneOfType([e.oneOf(["auto"]), e.number]),
    spacing: e.oneOfType([e.arrayOf(e.oneOfType([e.number, e.string])), e.number, e.object, e.string]),
    sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
    wrap: e.oneOf(["nowrap", "wrap-reverse", "wrap"]),
    xl: e.oneOfType([e.oneOf(["auto"]), e.number, e.bool]),
    xlOffset: e.oneOfType([e.oneOf(["auto"]), e.number]),
    xs: e.oneOfType([e.oneOf(["auto"]), e.number, e.bool]),
    xsOffset: e.oneOfType([e.oneOf(["auto"]), e.number])
  }), a.muiName = "Grid", a;
}
const A = De({
  createStyledComponent: be("div", {
    name: "MuiGrid2",
    slot: "Root",
    overridesResolver: (n, r) => r.root
  }),
  componentName: "MuiGrid2",
  useThemeProps: (n) => ye({
    props: n,
    name: "MuiGrid2"
  })
});
process.env.NODE_ENV !== "production" && (A.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: e.node,
  /**
   * @ignore
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object])
});
const Be = A;
export {
  Be as G,
  ze as r,
  $e as s
};
//# sourceMappingURL=Grid2-9c5e91ab.js.map
